import ImagePanelRepository from "../ImagePanelRepository"

export default class CompanyImagePanelRepository extends ImagePanelRepository {
    static schemaId = "company_imageSection"

    constructor() {
        super(CompanyImagePanelRepository.schemaId)
    }
}
